import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../common/GridNoRow';
import axios from "axios";
import Moment from 'moment';
import { AppContext } from '../../../AppStore';

function StockInfoModal({ title, id, onClose, item_type_name, item_division_name, item_name, item_spec }) {
  const appStore = useContext(AppContext);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: true,
    item_lot_pre_status: false,
    item_lot_post_status: false,
    pre_status_name: true,
    post_status_name: true,
    item_lot_save_pre_workplace_id: false,
    item_lot_save_pre_warehouse_id: false,
    item_lot_save_pre_section_id: false,
    item_lot_save_pre_workplace_name: false,
    item_lot_save_pre_warehouse_name: false,
    item_lot_save_pre_section_name: false,
    item_lot_save_post_workplace_id: false,
    item_lot_save_post_warehouse_id: false,
    item_lot_save_post_section_id: false,
    item_lot_save_post_workplace_name: false,
    item_lot_save_post_warehouse_name: false,
    item_lot_save_post_section_name: false,
    log_data: true,
    reg_user_id: false,
    reg_user_name: true,
    reg_datetime: true
  });

  useEffect(() => {
      // Mount 될때만 실행된다.
      handleSetting();
      handleInitSelect();
  }, [])

  useEffect(() => {
      //렌더링 될 때 마다 실행된다.

  });

  const handleSetting = () => {
    setColumns([
      { field: 'id', headerName: '순번', width: 70, headerAlign: 'center', align:'right' },
      { field: 'date', headerName: '기준일자', width: 120, headerAlign: 'center', align:'center' },
      { field: 'count_c', headerName: '생성수량', width: 100, headerAlign: 'center', align:'right' },
      { field: 'count_l', headerName: '분실수량', width: 100, headerAlign: 'center', align:'right' },
      { field: 'count_p', headerName: '계획수량', width: 100, headerAlign: 'center', align:'right' },
      { field: 'count_d', headerName: '소멸수량', width: 100, headerAlign: 'center', align:'right' },
      { field: 'recent_stock', headerName: '재고', width: 120, headerAlign: 'center', align:'right' },
      { field: 'recent_use_stock', headerName: '사용가능재고', width: 120, headerAlign: 'center', align:'right' }
    ]);

    setColumnVisibilityModel({
      id: true,
      date: true,
      count_c: true,
      count_l: true,
      count_p: true,
      count_d: true,
      recent_stock: true,
      recent_use_stock: true
    });
  }

  const handleInitSelect = () => {
    //조회
    axios.get('/api/p/StockInfo/StockList/'+id)
    .then((response) => {
        const array = response.data.map((item, index) => ({
          id: (Number(index)+1),
          date: item.date,
          count_c: item.count_c.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          count_d: item.count_d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          count_l: item.count_l.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          count_p: item.count_p.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          sum_count_c: item.sum_count_c.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          sum_count_d: item.sum_count_d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          sum_count_l: item.sum_count_l.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          sum_count_p: item.sum_count_p.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          recent_stock: item.recent_stock.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          recent_use_stock: item.recent_use_stock.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }));
        setRows(array);
    })
    .catch((error) => {
      appStore.capture();
    });
  }

  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <div>
            <table className="ModalTABLE">
              <tbody>

                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_filed">
                      <div className="modal_filed_title">품목</div>
                      <div className="modal_filed_input" style={ { display:'flex', width: '769px' } }>
                       <input type="text" style={ { width: '300px', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={item_name} name="item_name" autoComplete="off" readOnly />
                       &nbsp;&nbsp;
                       <input type="text" style={ { width: '80px', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={item_type_name} name="item_type_name" autoComplete="off" readOnly />
                       &nbsp;&nbsp;
                       <input type="text" style={ { width: '120px', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={item_division_name} name="item_division_name" autoComplete="off" readOnly />
                       &nbsp;&nbsp;
                       <input type="text" style={ { width: '300px', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={item_spec} name="item_spec" autoComplete="off" readOnly />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_grid" style={ { display:'block', height: '265px', paddingLeft: '0px', width: 'calc(100% - 50px)' } }>
                      <DataGrid
                        rows={rows}
                        columns={columns}
                        slots={{
                            noRowsOverlay: GridNoRow,
                        }}
                        columnVisibilityModel={columnVisibilityModel}
                        AlternatingRowBackground="LavenderBlush"
                        rowsPerPageOptions={[20, 50, 100]}
                        initialState={{ 
                            density: 'compact'
                        }}
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_action">
                      <div className="modal_button">
                        <Button 
                          onClick={()=> { onClose?.(); }}
                          className="btn-p"
                          sx={{  
                              m: 1, 
                              fontSize: 15, 
                              color: "white", 
                              borderColor: "#808080", 
                              backgroundColor: "#808080",
                              ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                          }} 
                          variant="outlined">
                          닫기
                        </Button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
    </PCModal>
  );
}

export default StockInfoModal;